<template>
  <div id="redirect-view">
    <app-form-header :title="$t('form.steps.redirect-nothing.title')"></app-form-header>
    <v-container fluid class="move-top-custom px-4 py-1">
      <v-row dense no-gutters>
        <div class="notes-container">
          <div>{{ $t('form.steps.redirect-nothing.notes') }}</div>
          <div class="highlight-green" v-html="$t('form.steps.redirect-nothing.notes2')"></div>
        </div>
      </v-row>
      <v-row>
        <!-- Nowy kontener grupujący przyciski class="button-text" -->
        <div class="actions-wrapper">
          <v-btn dark variant="outlined" color="white" class="menu-btn text-capitalize menu-btn--back font-weight-bold" @click="goBackClick()">
            {{ $t('back_btn') }}
          </v-btn>
          <v-btn color="primary" variant="contained" class="menu-btn text-capitalize font-weight-bold" @click="openInNewTab('https://pl.nothing.tech/pages/support-after-sales-service')">
            {{ $t('form.steps.redirect-nothing.button_title') }}
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  /*import { computed } from "vue";*/
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'RedirectView',
    computed: {
      ...mapGetters('ClaimForm', { claim_form: 'claim_form' }),
    },
    methods: {
      ...mapActions('ClaimForm', { updateClaimForm: 'updateClaimForm' }),
      openInNewTab(url) {
        window.open(url, '_blank');
        window.parent.postMessage({ closeModal: true }, '*');
      },
      goBackClick() {
        window.location.reload();
      }
    }
  }
</script>

<style scoped>
  /* Kontener dla przycisków */
  .actions-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center; /* Centrowanie przycisków w poziomie */
    align-items: center;
    gap: 12px; /* Odstęp między przyciskami */
    margin-top: 32px; /* Odstęp od sekcji notes */
    width: 100%;
  }

  .notes-container {
    width: 496px;
    height: 105px;
    font-family: 'Mulish', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0.05em;
    line-height: 140%; /* 21px */
    color: #7A7A7A;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin: 21px auto 0 auto;
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .highlight-green {
    color: #258569;
    display: block;
  }

  .button-text {
    /* Usunięto margin-top, bo teraz zarządza tym actions-wrapper */
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    gap: 10px;
    width: 272px;
    height: 44px;
    color: #FFFFFF;
    background: #258569;
    border-radius: 4px;
    flex: none;
    order: 1;
    flex-grow: 0;
    cursor: pointer;
  }

  .button-back {
    display: flex;
    flex-direction: row;
    justify-content: center; /* Zmieniono z flex-end na center dla balansu tekstu */
    align-items: center;
    padding: 12px 24px;
    gap: 10px;
    width: 89px;
    height: 44px;
    background: #D0D0D0;
    border-radius: 4px;
    flex: none;
    order: 0;
    flex-grow: 0;
    cursor: pointer;
  }

  .button-back-text {
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    letter-spacing: 0.03em;
    color: #FFFFFF;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .menu-btn {
    padding: 10px 18px 12px;
    min-height: 45px;
  }

  .menu-btn--back {
    background: #D0D0D0;
  }
</style>
